
import {Component} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NbButtonModule} from '@nebular/theme';
import {FormlyModule} from '@ngx-formly/core';
import { TuiIcon, TuiLabel, TuiTextfieldComponent, TuiTextfieldOptionsDirective, TuiInput } from '@taiga-ui/core';
import {TuiCalendarRange, TuiInputDateRangeDirective} from '@taiga-ui/kit';
import {BaseFieldType} from 'compob2b-libs';

@Component({
  templateUrl: './datepicker-range.component.html',
  imports: [
    FormsModule,
    FormlyModule,
    ReactiveFormsModule,
    TuiCalendarRange,
    TuiInputDateRangeDirective,
    TuiLabel,
    TuiTextfieldComponent,
    TuiTextfieldOptionsDirective,
    TuiInput,
    NbButtonModule,
    TuiIcon
]
})
export class DatepickerRangeComponent extends BaseFieldType {
}
